import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const scheduleBlocksService = {
  /**
   * Obter todas as ausências do usuário com paginação e filtros (BFF)
   * GET /api/blocks?page=1&pageSize=10&professionalId=xxx&placeId=xxx
   */
  getAll: async (page = 1, pageSize = 10, filters = {}) => {
    const params = { page, pageSize };
    if (filters.professionalId) params.professionalId = filters.professionalId;
    if (filters.placeId) params.placeId = filters.placeId;
    
    const response = await api.get('/blocks', { params });
    return extractData(response.data);
  },

  /**
   * Obter ausência específica por ID
   * GET /api/blocks/{id}
   */
  getById: async (id) => {
    const response = await api.get(`/blocks/${id}`);
    return extractData(response.data);
  },

  /**
   * Criar nova ausência
   * POST /api/blocks
   */
  create: async (data) => {
    const response = await api.post('/blocks', data);
    return extractData(response.data);
  },

  /**
   * Atualizar ausência
   * PUT /api/blocks/{id}
   */
  update: async (id, data) => {
    const response = await api.put(`/blocks/${id}`, data);
    return extractData(response.data);
  },

  /**
   * Deletar ausência
   * DELETE /api/blocks/{id}
   */
  delete: async (id) => {
    const response = await api.delete(`/blocks/${id}`);
    return extractData(response.data);
  },
};

export default scheduleBlocksService;
